import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import { connect } from 'react-redux';
import { Translation } from 'react-i18next';
import { cloneDeep } from 'lodash';
import ErrorMessage from '../ErrorMessage';
import validate from '../utility/CheckError';
import { checkUser } from '../../store/actions';
import { getTenantState } from '../../store/selectors';
import FormErrors from '../FormErrors';
import RouteBack from '../utility/RouteBack';
import CampusBackground from '../CampusBackground';
import IntroImage from '../IntroImage';
import PoweredBy from '../utility/PoweredBy';
import Fade from '../utility/Fade';
import eyeIcon from '../../ASUPhotos/icons/eyeIcon.png';
import eyeCrossIcon from '../../ASUPhotos/icons/eyeCrossIcon.png';

class ForgotPasswordVerification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      verificationcode: '',
      email: '',
      newpassword: '',
      errors: {
        emailEmpty: false,
        emailNotInUse: false,
        emailInvalid: false,
        password: false,
        code: false,
      },
      passwordIsMasked: true,
      showSuccess: false,
      // awful name, but it's standard to react-transition-group
      inProp: true,
    };
    this.togglePasswordMask = this.togglePasswordMask.bind(this);
  }

  handleErrors = async (event, inputValue) => {
    const errorsCopy = cloneDeep(this.state.errors);
    const stateCopy = cloneDeep(this.state);
    const errors = await validate(
      event.target.id,
      inputValue,
      errorsCopy,
      stateCopy
    );

    this.setState((prevState) => ({
      errors: { ...prevState.errors, ...errors },
    }));
  };

  togglePasswordMask = () => {
    this.setState((prevState) => ({
      passwordIsMasked: !prevState.passwordIsMasked,
    }));
  };

  keyDownPasswordMask = (e) => {
    if (['Enter'].includes(e.key)) {
      this.togglePasswordMask();
    }
  };

  handleSubmit = async (event) => {
    event.preventDefault();

    const { errors } = this.state;

    // AWS Cognito integration here
    try {
      await Auth.forgotPasswordSubmit(
        this.state.email,
        this.state.verificationcode,
        this.state.newpassword
      );
      this.setState({
        showSuccess: true,
      });
      setTimeout(() => {
        // Redirect user after they submit new password
        this.props.history.push('login');
      }, 5000);
    } catch (err) {
      const errorsCopy = cloneDeep(errors);

      errorsCopy.code = true;
      this.setState({
        errors: errorsCopy,
      });
      console.error(err);
    }
  };

  onInputChange = (event) => {
    if (event.target.id === 'email') {
      this.setState({
        email: event.target.value.toLowerCase(),
      });
    } else {
      this.setState({
        [event.target.id]: event.target.value,
      });
    }
  };

  visitLink() {
    const me3Link = 'https://edplus.asu.edu/what-we-do/me3';

    window.open(me3Link, '_blank');
  }

  render() {
    const { tenant } = this.props;
    const { passwordIsMasked, errors } = this.state;
    const primaryBackground = {
      backgroundColor: tenant.primary,
    };
    const primaryBorder = {
      borderTop: `5px solid ${tenant.primary}`,
    };
    const secondaryBorder = {
      borderBottom: `5px solid ${tenant.secondary}`,
    };
    const primaryColor = {
      color: `${tenant.primary}`,
    };

    return (
      <Translation>
        {(t) => (
          <CampusBackground secondaryColor={this.props.tenant.secondary}>
            <div className="verification-page verify">
              <div className="login-left" style={primaryBorder}>
                <div className="content">
                  <div className="header-container">
                    <RouteBack
                      color={this.props.tenant.primary}
                      route="/login"
                      tenant={this.props.tenant}
                      section="forgot your password?"
                      text="back"
                    />
                    <div className="main-header-container">
                      <h1>{t('Set New Password')}</h1>
                      <h2>
                        {t(
                          'Please enter the verification code sent to your email address below, and enter your email address and a new password'
                        )}
                      </h2>
                      <div className="fake-border" style={secondaryBorder} />
                    </div>
                  </div>
                  {this.state.showSuccess ? (
                    <div className="successful-change">
                      <p style={primaryColor}>
                        {t('Your password has been successfully updated!')}
                      </p>
                    </div>
                  ) : (
                    <Fade in={this.state.inProp}>
                      <FormErrors formerrors={this.state.errors} />
                      <form onSubmit={this.handleSubmit} className="login-form">
                        <div className="login-fields-container">
                          <div className="label-and-error">
                            <p style={primaryColor} className="login-text">
                              {t('Verification Code')}
                            </p>
                            <span
                              style={{ display: errors.code ? '' : 'none' }}
                            >
                              <ErrorMessage
                                error={t(
                                  'The verification code is incorrect, please enter correct code'
                                )}
                              />
                            </span>
                          </div>
                          <input
                            type="text"
                            className={errors.code ? 'error input' : 'input'}
                            id="verificationcode"
                            aria-label={t('verification code')}
                            value={this.state.verificationcode}
                            onChange={this.onInputChange}
                          />
                          <div className="label-and-error">
                            <p style={primaryColor} className="login-text">
                              {t('Enter Email')}
                            </p>
                            <span
                              style={{
                                display: errors.emailNotInUse ? '' : 'none',
                              }}
                            >
                              <ErrorMessage error={t("Email doesn't exist")} />
                            </span>
                            <span
                              style={{
                                display: errors.emailInvalid ? '' : 'none',
                              }}
                            >
                              <ErrorMessage error={t('Email Invalid')} />
                            </span>
                            <span
                              style={{
                                display: errors.emailEmpty ? '' : 'none',
                              }}
                            >
                              <ErrorMessage error={t('Field Required')} />
                            </span>
                          </div>
                          <input
                            className={
                              errors.emailNotInUse ||
                              errors.emailInvalid ||
                              errors.emailEmpty
                                ? 'error input'
                                : 'input'
                            }
                            type="email"
                            id="email"
                            data-cy="email"
                            aria-label={t('email')}
                            onChange={this.onInputChange}
                            onBlur={(event) => {
                              this.handleErrors(event, this.state.email);
                            }}
                          />
                          <div className="input-container">
                            <div className="label-and-error">
                              <p style={primaryColor} className="login-text">
                                {t('New Password')}
                              </p>
                              <span
                                style={{
                                  display: errors.password ? '' : 'none',
                                }}
                              >
                                <ErrorMessage
                                  error={t(
                                    `Password doesn't meet requirements`
                                  )}
                                />
                              </span>
                            </div>
                            <div className="login-password">
                              <input
                                type={passwordIsMasked ? 'password' : 'text'}
                                aria-label={t('password')}
                                className={
                                  errors.password ? 'error input' : 'input'
                                }
                                id="newpassword"
                                placeholder="•••••••••"
                                value={this.state.newpassword}
                                onChange={this.onInputChange}
                                onBlur={(event) => {
                                  this.handleErrors(event, this.state.password);
                                }}
                              />
                              <img
                                className="password-eye"
                                onClick={this.togglePasswordMask}
                                onKeyDown={this.keyDownPasswordMask}
                                src={passwordIsMasked ? eyeIcon : eyeCrossIcon}
                                alt="eye"
                                tabIndex="0"
                                role="button"
                                aria-label={t('view password button')}
                                aria-pressed={!passwordIsMasked}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="input-bottom">
                          <div className="login-button-container">
                            <button
                              style={primaryBackground}
                              className="button--primary login-button"
                              id="submit"
                              type="submit"
                              data-cy="submit"
                            >
                              {t('Submit')}
                            </button>
                          </div>
                        </div>
                      </form>
                    </Fade>
                  )}
                </div>
                <PoweredBy tenant={null} />
              </div>
              <IntroImage showTutorial={false} />
            </div>
          </CampusBackground>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => {
  const tenant = getTenantState(state);

  return { tenant };
};

const ConnectedForgotPasswordVerification = withRouter(
  connect(mapStateToProps, {
    checkUser,
  })(ForgotPasswordVerification)
);

export default ConnectedForgotPasswordVerification;
